export default __webpack_public_path__ + "static/GT-America-Extended-Bold-Italic-6bb21548600374628033d510acada4a2.woff";